import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// Components
import Text from "new_components/atoms/Text";
import Icon from "new_components/atoms/Icon";
import { ICON_SET } from "new_components/atoms/Icon/IconSet";

// Constants
import colors from "styles/colors";
import typography from "styles/typography";

// Button Container
const ButtonContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 12px;
  background-color: ${({ hasData }) => 
    hasData ? colors.primary[50] : colors.neutral[100]};
  border: 1px solid ${({ hasData }) => 
    hasData ? colors.primary[200] : colors.neutral[200]};
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
  margin: 8px;

  &:hover {
    background-color: ${({ hasData }) => 
      hasData ? colors.primary[100] : colors.neutral[200]};
    border-color: ${({ hasData }) => 
      hasData ? colors.primary[300] : colors.neutral[300]};
  }

  &:active {
    transform: translateY(1px);
  }
`;

// Left Content
const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

// Counter Badge
const CounterBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ hasData }) => 
    hasData ? colors.primary[500] : colors.neutral[400]};
  color: white;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 0 2px;
`;

// Text Container
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

const DataSourceButton = ({ 
  selectedCount = 0, 
  onClick,
  disabled = false 
}) => {
  const hasData = selectedCount > 0;
  


  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <ButtonContainer 
      hasData={hasData}
      onClick={handleClick}
      disabled={disabled}
      type="button"
    >
      <LeftContent>
        <Icon 
          name={ICON_SET.database} 
          size={18} 
          color={hasData ? colors.primary[500] : colors.neutral[400]}
        />
        <TextContainer>
          <Text 
            typographyStyle={typography.smallText.semibold}
            color={hasData ? colors.primary[700] : colors.neutral[600]}
          >
            Survey Data{hasData ? ` (${selectedCount})` : ''}
          </Text>
          {hasData && (
            <Text 
              typographyStyle={typography.smallText.regular}
              color={colors.text.gray}
            >
              {selectedCount} source{selectedCount !== 1 ? 's' : ''} selected
            </Text>
          )}
          {!hasData && (
            <Text 
              typographyStyle={typography.smallText.regular}
              color={colors.text.gray}
            >
              Click to add survey data
            </Text>
          )}
        </TextContainer>
      </LeftContent>
      
      {hasData && (
        <CounterBadge hasData={hasData}>
          {selectedCount > 99 ? "99+" : selectedCount}
        </CounterBadge>
      )}
    </ButtonContainer>
  );
};

DataSourceButton.propTypes = {
  selectedCount: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default DataSourceButton; 